var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":""}},[_c('line-chart',{attrs:{"title":"Sessions et CA","colors":_vm.colors,"series":_vm.series,"labels":_vm.labels,"yAxis":_vm.yAxis,"xAxis":_vm.xAxis,"stroke":_vm.stroke,"outlined":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }